import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/entities/session/model/authStore';
import { useAiReports } from '@/features/ai/api/aiApi';
import { TruncatedText } from '@/shared/ui/TruncatedText';
import { useTabsStore } from '../tabs/tabsStore';
import { useShellStore } from '../model/shellStore';

/**
 * Kullanıcının menüye kaydettiği AI raporları. Menü grubu ve bölüm şeridindeki sayaç aynı
 * sorguyu okuyor. AI yetkisi olmayan kullanıcıda istek atılmaz: rapor ancak AI ile üretilir.
 */
export function useAiReportsMenu() {
  const user = useAuthStore((s) => s.user);
  const { data } = useAiReports(user?.userId ?? null, !!user?.canUseAiChat);
  return data ?? [];
}

/** Menüdeki "AI Raporları" grubu — /api/aichat/reports?userId. */
export function AiReportsGroup({ headless = false }: { headless?: boolean } = {}) {
  const { t } = useTranslation();
  const openCustom = useTabsStore((s) => s.openCustom);
  const setDrawer = useShellStore((s) => s.setDrawer);
  const items = useAiReportsMenu();
  if (!items.length) return null;
  return (
    <section className="mb-2">
      {!headless ? (
        <h3 className="text-fg-subtle flex items-center gap-1 px-2 py-1 text-[11px] font-semibold tracking-wide uppercase">
          <Sparkles className="h-3 w-3" /> {t('shell.aiReports')}
        </h3>
      ) : null}
      {items.map((r) => (
        <button
          key={r.reportId}
          type="button"
          onClick={() => {
            openCustom({
              kind: 'aireport',
              caption: r.title,
              params: { reportId: r.reportId },
              uniqueKey: `aireport:${r.reportId}`,
            });
            setDrawer(false);
          }}
          className="hover:bg-bg-hover flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm"
          title={r.hasParameters ? t('ai.artifact.parametric') : undefined}
        >
          <Sparkles className="text-brand-600 h-4 w-4" />
          <TruncatedText text={r.title} className="min-w-0 flex-1" />
        </button>
      ))}
    </section>
  );
}
